import { render, staticRenderFns } from "./ProjectActionButtons.vue?vue&type=template&id=1143972e&scoped=true"
import script from "./ProjectActionButtons.vue?vue&type=script&lang=ts"
export * from "./ProjectActionButtons.vue?vue&type=script&lang=ts"
import style0 from "./ProjectActionButtons.vue?vue&type=style&index=0&id=1143972e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1143972e",
  null
  
)

export default component.exports